// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"aaa56057","239":"71ad1da2","667":"bff17d78"}[chunkId] + ".chunk.js";
};